import * as XLSX from '@e965/xlsx';

import type { Row, XlsColumn, XlsWorkbook } from './types';

function workbookToXlsWorkbook(wb: XLSX.WorkBook): XlsWorkbook {
  return {
    sheetNames: wb.SheetNames,
    getHeaders: (sheet) => {
      const ws = wb.Sheets[sheet];
      const raw = XLSX.utils.sheet_to_json<string[]>(ws, { header: 1 });
      return (raw[0] ?? []).map(String);
    },
    getRows: (sheet) => {
      const ws = wb.Sheets[sheet];
      return XLSX.utils.sheet_to_json<Row>(ws, { defval: '' });
    },
  };
}

export function readXls(file: File): Promise<XlsWorkbook> {
  return file
    .arrayBuffer()
    .then((buffer) => workbookToXlsWorkbook(XLSX.read(buffer, { type: 'array' })));
}

export type XlsSheet = {
  name: string;
  rows: Row[];
  columns: XlsColumn[];
  title?: string;
};

export function readXlsFromBuffer(buffer: Buffer): XlsWorkbook {
  return workbookToXlsWorkbook(XLSX.read(buffer, { type: 'buffer' }));
}

export async function exportXls(sheets: XlsSheet[], filename: string): Promise<void> {
  const wb = XLSX.utils.book_new();

  for (const { name, rows, columns, title } of sheets) {
    const headers = columns.map((c) => c.header);
    const aoa = [
      ...(title ? [[title]] : []),
      headers,
      ...rows.map((row) => columns.map((c) => row[c.key] ?? '')),
    ];
    const ws = XLSX.utils.aoa_to_sheet(aoa);
    ws['!cols'] = columns.map((c) => ({ wch: c.width ?? 15 }));
    if (title) {
      ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: columns.length - 1 } }];
    }
    XLSX.utils.book_append_sheet(wb, ws, name);
  }

  XLSX.writeFile(wb, `${filename}.xlsx`);
}
